import React from 'react';

const reasons = [
  {
    title: 'Experienced local team',
    text: 'Our crew brings practical knowledge, dependable scheduling, and consistent results to every residential and commercial property.'
  },
  {
    title: 'Attention to detail',
    text: 'We focus on the details that matter most, from clean edging and careful snow clearing to reliable follow-through on every service visit.'
  },
  {
    title: 'Transparent communication',
    text: 'You can count on clear updates, fair service recommendations, and a straightforward experience from quote to completion.'
  },
  {
    title: 'Property-first care',
    text: 'Every property is treated with respect, and we work to keep your outdoor spaces neat, safe, and ready for the season.'
  }
];

const WhyChooseUsSection = () => {
  return (
    <section className="py-4 md:py-6 bg-[#f4f8f0]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-12">
          <p className="text-sm font-semibold uppercase tracking-[0.2em] text-[#3f9422]">Why Choose Us</p>
          <h2 className="mt-3 text-3xl md:text-5xl font-black text-gray-900">Dependable outdoor care for every season</h2>
        </div>

        <div className="grid gap-6 md:grid-cols-2 xl:grid-cols-4">
          {reasons.map((reason) => (
            <div key={reason.title} className="rounded-2xl border border-gray-200 bg-white p-6 shadow-sm hover:shadow-md transition-shadow">
              <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-[#eaf7df] text-2xl text-[#3f9422]">✓</div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">{reason.title}</h3>
              <p className="text-gray-700 leading-7">{reason.text}</p>
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <a href="/why-choose-us" className="inline-flex items-center justify-center rounded-full bg-[#3f9422] px-6 py-3 text-base font-semibold text-white shadow-md transition hover:bg-[#2e7a1b]">
            Learn More About Us
          </a>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUsSection;
